export default function capitalizeLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
